"use strict";
import * as React from "react";
import Thumbnail from "./Thumbnail";

const PortfolioColumn = ({ imageList, openGallery }) => (
  <div className="col-md-4 col-sm-6 column">
    {imageList.map((image, index) => (
      <Thumbnail imageData={image} openGallery={openGallery} key={index} />
    ))}
  </div>
);

export default PortfolioColumn;



// WEBPACK FOOTER //
// ./src/components/PortfolioColumn.js